<script lang="ts" setup>
import useCatalogStore from '~/shared/store/modules/catalog';
import type { TCatalogSorting } from '~/shared/interfaces/catalog';

const catalogStore = useCatalogStore();

</script>

<template>
  <div class="sorting">
    <span class="sorting-name">Сортировка:</span>
    <div class="sorting-wrapper">
      <span
        v-for="(sortName, sortType) in catalogStore.sortingList"
        class="sorting-sort"
        :class="sortType == catalogStore.selectedFilters.sorting && 'sorting-sort_active'"
        @click="catalogStore.setCatalogSorting(sortType)"
      >
        {{ sortName }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sorting {
  display: flex;
  gap: 12px;
  padding: 0 12px;
  &-name {
    color: $control-content_secondary;
  }
  &-sort {
    color: $control-content_primary;
    cursor: pointer;
    transition: color .3s;

    &:hover:not(:active, .sorting-sort_active) {
      @include mf-breakpoint {
        color: $control-content_orange;
      }
    }

    &_active {
      color: $control-content_orange;
    }
  }
  &-name, &-sort {
    @include font(14px, 20px);
  }
  &-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}
</style>
